import { MicroFrontendPropsService, ServiceboxAppConfigModule, ServiceboxMicrofrontendsModule, WINDOW_PROVIDERS } from '@adnoc/servicebox';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AdnocLogoComponent } from '@lms-approval/shared/ui';
import { RouterModule } from '@angular/router';
import { ParcelModule } from 'single-spa-angular/parcel';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

import {
  SandboxComponent,
  SandboxMenuComponent,
  SandboxMobileSwitchConfirmationComponent,
  SandboxWrapperComponent,
} from './components';
import {
  SandboxDarkModeService,
  SandboxLocalStorageService,
  SandboxMobileService,
} from './services';
import { MatCard, MatCardContent, MatCardTitle } from '@angular/material/card';
import { OnehubFormUiModule } from '@adnoc/onehub-form-ui';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    SandboxComponent,
    SandboxWrapperComponent,
    SandboxMenuComponent,
    SandboxMobileSwitchConfirmationComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ParcelModule,
    MatDialogModule,
    MatButtonModule,
    ServiceboxMicrofrontendsModule,
    AdnocLogoComponent,
    MatCard,
    MatCardTitle,
    MatCardContent,
    OnehubFormUiModule,
    ReactiveFormsModule
  ],
  providers: [
    WINDOW_PROVIDERS,
    SandboxDarkModeService,
    ServiceboxAppConfigModule,
    SandboxLocalStorageService,
    SandboxMobileService,
  ],
})
export class OneHubSandboxModule {}
